import fig1 from '../../../Assets/sdmtfigures/symbol-01.svg';
import fig2 from '../../../Assets/sdmtfigures/symbol-02.svg';
import fig3 from '../../../Assets/sdmtfigures/symbol-03.svg';
import fig4 from '../../../Assets/sdmtfigures/symbol-04.svg';
import fig5 from '../../../Assets/sdmtfigures/symbol-05.svg';
import fig6 from '../../../Assets/sdmtfigures/symbol-06.svg';
import fig7 from '../../../Assets/sdmtfigures/symbol-07.svg';
import fig8 from '../../../Assets/sdmtfigures/symbol-08.svg';
import fig9 from '../../../Assets/sdmtfigures/symbol-09.svg';

export const figures: { [key: number]: SVGSVGElement } = {
  1: <SVGSVGElement>fig1,
  2: <SVGSVGElement>fig2,
  3: <SVGSVGElement>fig3,
  4: <SVGSVGElement>fig4,
  5: <SVGSVGElement>fig5,
  6: <SVGSVGElement>fig6,
  7: <SVGSVGElement>fig7,
  8: <SVGSVGElement>fig8,
  9: <SVGSVGElement>fig9,
};

// config for symbols of sdmt test
export const sdmtSymbolConfig = [1, 2, 3, 4, 5, 6, 7, 8, 9];

// config for practice section of sdmt test
export const sdmtPracticeConfig = [1, 5, 2, 1, 3, 6, 2, 4, 1, 6];

// config for the sdmt test itself
export const sdmtTestConfig = [
  2, 1, 6, 1, 2, 4, 6, 1, 2, 5, 6, 3, 4, 1, 2, 6, 9, 4, 3, 8, 4, 5, 7, 8, 1, 3, 7, 4, 8, 5, 2, 9, 3, 4, 7, 2, 4, 5, 1,
  6, 4, 1, 5, 6, 7, 9, 8, 3, 6, 4, 9, 5, 8, 3, 6, 7, 4, 5, 2, 3, 7, 9, 2, 8, 1, 6, 9, 7, 2, 3, 6, 4, 9, 1, 7, 2, 5, 6,
  8, 4, 2, 8, 7, 9, 3, 7, 8, 5, 1, 9, 2, 1, 4, 3, 6, 5, 2, 1, 6, 4, 2, 1, 6, 9, 7, 3, 5, 4, 8, 9,
];
